import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-navy-950 text-cream-100">
      <div className="border-t border-cream-100/10"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/435f6bd6c74db995a4c06e524059bc0b.png"
              alt="Karşıyaka Visa Consulting"
              className="h-14 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-cream-300 text-sm mb-4">
              İzmir vize danışmanlığı alanında 12 yıllık deneyim ile güvenilir hizmet sunuyoruz.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://wa.me/905514803007?text=Merhaba%20ben%20sizinle%20karsiyakavisaconsulting.com.tr%20sitesinden%20iletisime%20geciyorum"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-cream-300/30 text-cream-300 hover:bg-cream-400 hover:text-navy-900 transition-all cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-fill"></i>
              </a>
              <a
                href="tel:+905514803007"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-cream-300/30 text-cream-300 hover:bg-cream-400 hover:text-navy-900 transition-all cursor-pointer"
                aria-label="Telefon"
              >
                <i className="ri-phone-fill"></i>
              </a>
              <a
                href="mailto:karsiyakavisaconsulting@gmail.com"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-cream-300/30 text-cream-300 hover:bg-cream-400 hover:text-navy-900 transition-all cursor-pointer"
                aria-label="E-posta"
              >
                <i className="ri-mail-fill"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display font-semibold text-cream-100 mb-4">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-cream-300 text-sm hover:text-cream-100 transition-colors">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-cream-300 text-sm hover:text-cream-100 transition-colors">
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-cream-300 text-sm hover:text-cream-100 transition-colors">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-cream-300 text-sm hover:text-cream-100 transition-colors">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display font-semibold text-cream-100 mb-4">Hizmetlerimiz</h4>
            <ul className="space-y-2">
              <li className="text-cream-300 text-sm">Schengen Vizesi</li>
              <li className="text-cream-300 text-sm">Amerika Vizesi</li>
              <li className="text-cream-300 text-sm">İngiltere Vizesi</li>
              <li className="text-cream-300 text-sm">Oturum Kartı</li>
              <li className="text-cream-300 text-sm">Aile Birleşimi</li>
              <li className="text-cream-300 text-sm">E-Vize Hizmetleri</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-display font-semibold text-cream-100 mb-4">İletişim Bilgileri</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-fill text-cream-400 mt-1"></i>
                <p className="text-cream-300 text-sm">
                  Tuna Mah. Kemalpaşa Cad. Kat:5/506<br />
                  Ses İş Hanı Karşıyaka / İzmir
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-fill text-cream-400"></i>
                <a href="tel:+905514803007" className="text-cream-300 text-sm hover:text-cream-100 cursor-pointer">
                  +90 551 480 3007
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-fill text-cream-400"></i>
                <a href="mailto:karsiyakavisaconsulting@gmail.com" className="text-cream-300 text-sm hover:text-cream-100 cursor-pointer">
                  karsiyakavisaconsulting@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-cream-100/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-cream-400 text-sm">
              © 2025 Karşıyaka Visa Consulting. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/kvkk" className="text-cream-400 text-sm hover:text-cream-100 transition-colors">
                KVKK Aydınlatma Metni
              </Link>
              <Link to="/cerez-politikasi" className="text-cream-400 text-sm hover:text-cream-100 transition-colors">
                Çerez Politikası
              </Link>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="nofollow noopener noreferrer" 
                className="text-cream-400 text-sm hover:text-cream-100 transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;